import { useDrawer } from 'components/drawers/inc-drawer/inc-drawer.hooks';
import { RefundTransactionDrawerDataType } from './refund-transaction-drawer.component';

export const useRefundTransactionDrawer = () =>
  useDrawer<RefundTransactionDrawerDataType>();
